import { Pipe, PipeTransform } from '@angular/core';

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

export function toFileSize(bytes: number = 0, decimals: number = 2): string {
    if (!+bytes) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${units[i]}`;
}

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
    transform(bytes: number = 0, decimals: number = 2): string {
        return toFileSize(bytes, decimals);
    }
}
